<template>
    <div class="section-box">
        <el-tabs v-model="form.status" type="card" class="customer-tabs-mg" @tab-click="handleSearch()">
            <el-tab-pane v-for="(item, index) in tabList" :label="item.value" :name="item.key + ''" :key="index+''">
            </el-tab-pane>
        </el-tabs>
        <div class="customer-list-series">
            <div class="next-button">
                <el-button size="small" type="primary" icon="el-icon-plus" plain @click="openSerialModl()">新增</el-button>
                <el-button size="small" type="primary" @click="handleSearch">查询</el-button>
                <el-button size="small" type="success" @click="handleReset">重置</el-button>
            </div>
        </div>
        <!-- eslint-disable  -->
        <el-table
                ref='table'
                :stripe="true"
                :data="tableData"
                style="width: 100%"
                height="670"
                border
                v-loading="listLoading"
                :key="toggleIndex"
        >
            <el-table-column label="系列编号">
                <el-table-column show-overflow-tooltip>
                    <template slot="header" slot-scope="scope">
                        <el-input type="number" size="mini" v-model.trim="form.id" placeholder="请输入编号搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.id || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="所属领域">
                <el-table-column show-overflow-tooltip >
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model.trim="form.domainName" placeholder="请输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.domainName || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="所属一级产品">
                <el-table-column show-overflow-tooltip >
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model.trim="form.firstProductName" placeholder="请输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.firstProductName || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="所属二级产品">
                <el-table-column show-overflow-tooltip >
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model.trim="form.secondProductName" placeholder="请输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.secondProductName || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="所属三级产品">
                <el-table-column show-overflow-tooltip >
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model.trim="form.thirdProductName" placeholder="请输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.thirdProductName || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="所属品牌">
                <el-table-column show-overflow-tooltip >
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model.trim="form.brandName" placeholder="请输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.brandName || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="系列名称">
                <el-table-column show-overflow-tooltip >
                    <template slot="header" slot-scope="scope">
                        <el-input size="mini" v-model.trim="form.serialName" placeholder="请输入关键字搜索"/>
                    </template>
                    <template slot-scope="scope">
                        <span>{{scope.row.serialName || '--'}}</span>
                    </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="操作" fixed="right"  width="200">
                <template slot-scope="scope">
                    <el-button size="mini" v-if="scope.row.status" @click="openmodfMod(scope.row)">修改</el-button>
                    <el-button size="mini" type="primary" v-if="!scope.row.status" @click="confirmZF(true,scope.row.id)">恢复</el-button>
                    <el-button size="mini" type="warning" v-if="scope.row.status" @click="openZFModel(scope.row)">作废</el-button>
                </template>
            </el-table-column>
        </el-table>
        <div style="margin: 10px;overflow: hidden">
            <div style="float: right;" v-show="tableData.length">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="form.pageNum"
                        :page-sizes="[10, 20, 50, 100, 200]"
                        :page-size="form.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total">
                </el-pagination>
            </div>
        </div>
        <add-serial
                ref="addSerial"
                v-if="showSerial"
                :current-param="currentlevelParam"
                @close="closeSerial"
                @refreshList="successSerial">
        </add-serial>
        <el-dialog
                title="作废操作"
                :visible="showZFModel"
                :close-on-click-modal="!showZFModel"
                :before-close="closeZFModel"
                width="500px"
        >
            <div class="pad-20">
                <h3>您正在执行作废操作，一旦确认，【{{zfname}}】品牌将被作废，请谨慎操作</h3>
                <div class="dialog-footer" style="text-align: center;margin-top: 40px;" slot="footer">
                    <el-button type="primary" @click="confirmZF(false,-2)">确认作废</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import { getserialList,updateserial} from "@/service/dataFrame";
    import addSerial from './index/addSerial';
    import { getStorageUserRoleId,getActionData } from '@/utils/store'
    export default {
        name: "seriesLibrary",
        components:{addSerial},
        data(){
            return{
                tableData:[],
                listLoading:false,
                currentlevelParam:{},
                form:{
                    id:'',
                    serialName:'',
                    domainName:'',
                    firstProductName:'',
                    secondProductName:'',
                    thirdProductName:'',
                    brandName:'',
                    status:'1',
                    pageNum: 1,
                    pageSize: 10
                },
                total: 0,
                searchData:{},
                toggleIndex:0,
                tabList:[
                    {key:'1',value:'有效系列'},
                    {key:'0',value:'无效系列'},
                ],
                oraginForm:{},
                showSerial:false,
                showZFModel:false,//作废
                zfname:'',
                zfModl:{}
            }
        },
        activated(){
            this.handleSearch()
        },
        created() {
            this.oraginForm = JSON.parse(JSON.stringify(this.form))
            this.tableData = [];
            this.handleSearch()
        },
        methods:{
            successSerial(){
                this.getSeriallist();
            },
            handleSearch(){
                this.searchData = Object.assign({}, this.form)
                this.form.pageNum = 1;
                this.searchData.pageNum = 1;
                this.getSeriallist();
            },
            async getSeriallist(){
                this.listLoading = true;
                this.toggleIndex=this.form.status;
                let data = JSON.parse(JSON.stringify(this.searchData))
                !data.id && delete data.id
                !data.serialName && delete data.serialName
                !data.domainName && delete data.domainName
                !data.firstProductName  && delete data.firstProductName
                !data.secondProductName  && delete data.secondProductName
                !data.thirdProductName && delete data.thirdProductName
                !data.brandName && delete data.brandName
                data.status=this.form.status==1?true:false
                let res = await getserialList(data)
                this.listLoading = false
                if(res.Result != 1) {
                    return this.$message.error('获取失败请联系开发人员')
                }
                this.tableData = res.Data.datas || [];
                this.total = res.Data.total;
                this.$nextTick(() => {
                    this.$refs.table.bodyWrapper.scrollTop = 0
                    this.$refs.table.doLayout()
                })
            },
            handleSizeChange(val) {
                if (this.listLoading) return
                this.form.pageNum = 1
                this.form.pageSize = val;
                this.searchData.pageNum = 1
                this.searchData.pageSize = val;
                this.getSeriallist();
            },
            handleCurrentChange(val) {
                if (this.listLoading) return
                this.form.pageNum = val;
                this.searchData.pageNum = val;
                this.getSeriallist();
            },
            openZFModel(data){
                this.showZFModel=true;
                this.zfname=data.serialName;
                this.zfModl={
                    id:data.id,
                }
            },
            confirmZF(data,id){
                let param={
                    status:data,
                    userId:getStorageUserRoleId()
                }
                if(id>-1){
                    param.id=id
                }else{
                    param.id=this.zfModl.id
                }
                updateserial(param).then((res)=>{
                    if(res.Result != 1) {
                        return this.$message.error(res.Message)
                    }
                    this.showZFModel=false;
                    this.$message.success("操作成功")
                    if(data){
                        this.form.status = '1';
                    }else{
                        this.form.status = '0';
                    }
                    this.getSeriallist();
                })
                console.log("作废")
            },
            closeZFModel(){
                this.showZFModel=false;
            },
            openSerialModl(){
                this.currentlevelParam={
                    update:-1
                }
                this.showSerial=true;
            },
            closeSerial(){
                this.showSerial=false;
            },
            // 重置
            handleReset() {
                this.form = JSON.parse(JSON.stringify(this.oraginForm))
                this.handleSearch()
            },
            // 修改系列
            openmodfMod(data){
                this.currentlevelParam=data;
                this.currentlevelParam.update=1;
                this.showSerial=true;
            }
        }
    }
</script>

<style lang="scss">
    .customer-list-series {
        position: relative;

        .next-button {
            position: absolute;
            right: 0;
            top: -56px;
        }
    }
</style>
